import axios from 'axios';
import { apiPath, config,getAuthConfig,getConfigJWT } from '../config/ApiConfig';

//JWT token
export function getJWT(endPoint, inputParam, sucessCallback, errorCallback) {
    const jwtConfig = getConfigJWT();
    return axios.get(`${apiPath}${endPoint}${inputParam}`, jwtConfig)
        .then(response => response.data)
        .then(sucessCallback)
        .catch(errorCallback);
}

export function postJWT(endPoint, inputParam, sucessCallback, errorCallback) {
    const jwtConfig = getConfigJWT();
     return axios.post(`${apiPath}${endPoint}`,{...inputParam}, jwtConfig)
        	.then(response => response.data)
        	.then(sucessCallback)
            .catch(errorCallback);
}

// HMAC token
export async function getHMAC(endPoint, inputParam, successCallback, errorCallback) {
    try {
        const config = await getAuthConfig();

        const response = await axios.get(
            `${apiPath}${endPoint}${inputParam}`,
            config
        );

        const data = response.data;

        if (successCallback) successCallback(data);
        return data;

    } catch (error) {
        if (errorCallback) errorCallback(error);
    }
}
export async function postFormDataHMAC(endPoint, inputParam, successCallback, errorCallback) {
    try {
        const config = await getAuthConfig();

        const response = await axios.post(
            `${apiPath}${endPoint}`,
            inputParam,
            {
                ...config,
                maxBodyLength: Infinity,
                maxContentLength: Infinity
            }
        );

        const data = response.data;

        if (successCallback) successCallback(data);

        return data;

    } catch (error) {
        if (errorCallback) errorCallback(error);
        throw error;
    }
}

export async function postHMAC(endPoint, inputParam, successCallback, errorCallback) {
    try {
        const config = await getAuthConfig();

        const response = await axios.post(
            `${apiPath}${endPoint}`,
            { ...inputParam },
            config
        );

        const data = response.data;

        if (successCallback) successCallback(data);

        return data;

    } catch (error) {
        if (errorCallback) errorCallback(error);
    }
}

export function get(endPoint, inputParam, sucessCallback, errorCallback) {
    return axios.get(`${apiPath}${endPoint}${inputParam}`, config)
        	.then(response => response.data)
        	.then(sucessCallback)
            .catch(errorCallback);
 }

 export function getVippsAuthInfo(endPoint, sucessCallback, errorCallback) {
    return axios.get(`${endPoint}`)
        	.then(response => response.data)
        	.then(sucessCallback)
            .catch(errorCallback);
 }

export async function downloadDocument(downloadUrl, successCallback, errorCallback) {
    try {
        const config = await getAuthConfig();

        const response = await axios.get(`${apiPath}${downloadUrl}`, {
            ...config,
            responseType: 'blob'
        });

        if (successCallback) successCallback(response);
        return response;
    } catch (error) {
        if (errorCallback) errorCallback(error);
        throw error;
    }
}
 export function post(endPoint, inputParam, sucessCallback, errorCallback) {
    return axios.post(`${apiPath}${endPoint}`,{...inputParam}, config)
        	.then(response => response.data)
        	.then(sucessCallback)
            .catch(errorCallback);
 }

 